import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticleUltimateGuide from "@/pages/articles/cssbuy-spreadsheet-ultimate-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articles/cssbuy-spreadsheet-ultimate-guide",
    element: <ArticleUltimateGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;